import React, { JSX } from "react";
import { PciDashboardScenarioTypeEnum } from "@app/projects/network-assessment/pci-dashboard/shared";

function getPciDashboardScenarioChangeDisplay(displayNumber: number, round?: boolean, showPercentage?: boolean): JSX.Element {
  if (!displayNumber) {
    return (
      <React.Fragment>
        ---
      </React.Fragment>
    );
  }

  if (displayNumber < 0) {
    displayNumber = Math.abs(displayNumber);

    return (
      <React.Fragment>
        <i className="fa fa-long-arrow-down text-muted" /> {round ? getRoundingDisplay(displayNumber, showPercentage) : displayNumber}
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <i className="fa fa-long-arrow-up text-info" /> {round ? getRoundingDisplay(displayNumber, showPercentage) : displayNumber}
      </React.Fragment>
    );
  }
}

function getRoundingDisplay(displayNumber: number, showPercentage?: boolean, decimalFixed: number = 1): string {
  if (!displayNumber) {
    return "---";
  }

  let display;

  if (displayNumber < 0.1) {
    display = "<0.1";
  } else {
    display = displayNumber.toFixed(decimalFixed);
  }

  return `${display}${showPercentage ? "%" : ""}`;
}

function getScenarioDisplay(scenarioType: PciDashboardScenarioTypeEnum): string {
  switch (scenarioType) {
    case PciDashboardScenarioTypeEnum.Targeted:
      return "Projected";
    case PciDashboardScenarioTypeEnum.Terminated:
      return "Termed";
    case PciDashboardScenarioTypeEnum.TermTargeted:
      return "Projected-Termed";
    default:
      return;
  }
}

export {
  getPciDashboardScenarioChangeDisplay,
  getRoundingDisplay,
  getScenarioDisplay,
}